import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Col, Container, Icon, Row } from '@mch-group/uikit-components'
import dynamic from 'next/dynamic'
import Text from '../../Text'
import { px2rem } from '../../../utils'
import LazyImage from '../../Image/LazyImage'
import cssClasses from '../../../constants/cssClasses'
import YouTubeIFRAME from './YoutubeIFRAME'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'
import React from 'react'

const mID = 'rm-videom'
const { cloudinary } = getEnvConfig.fe

const DynamicLoader = () => (
  <Container className='px-5 px-lg-8 px-md-7'>
    Loading...
  </Container>
)

const VideoJSPlayer = dynamic({
  loader: () => import(/* webpackChunkName: 'VideoJSPlayer' */ './VideoJSPlayer'),
  loading: () => <DynamicLoader />,
  ssr: false
})

const media = propsMedia => (propsMedia || 'upload-video')

class VideoM extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    video_module_caption: PropTypes.string,
    video_module_reference: PropTypes.string,
    video_module_meida: PropTypes.string,
    video_module_subtitle_1_language: PropTypes.string,
    video_module_subtitle_2_language: PropTypes.string,
    video_module_subtitle_1_order: PropTypes.string,
    video_module_subtitle_2_order: PropTypes.string,
    video_module_subtitle_1_default: PropTypes.string,
    video_module_subtitle_2_default: PropTypes.string,
    video_module_youtube_link: PropTypes.string,
    video_module_subtitle_1: PropTypes.string,
    video_module_subtitle_2: PropTypes.string,
    id: PropTypes.number
  }

  state = {
    previewImage: '',
    videoActive: true // should be false for dynamic loading but got many issues, so not show directly for now
  }

  componentDidMount() {
    const { props }: any = this
    const youtubeUrl = props.video_module_youtube_link
    const videoFile = props.video_module_reference || null
    let videoPoster = ''

    if (media(props.video_module_meida) === 'upload-video') {
      videoPoster = `https://res.cloudinary.com/${cloudinary.name}/video/upload/${videoFile}.jpg`
    } else if (youtubeUrl) {
      const youtubeId = this.parseYoutubeUrl(youtubeUrl)
      videoPoster = `https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`
    }
    this.setState({ previewImage: videoPoster })
  }

  onToggleVideo = (event) => {
    event.preventDefault()
    this.setState({ videoActive: !this.state.videoActive })
  }

  parseYoutubeUrl = (url) => {
    {/* https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url */ }

    let youtubeId = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
    return youtubeId[2] !== undefined ? youtubeId[2].split(/[^0-9a-z_\\-]/i)[0] : youtubeId[0]
  }

  render() {
    const { props, state }: any = this
    const { previewImage, videoActive } = state

    return (
      // @ts-ignore
      <Container id={this.props.id} className={`${this.props.className} px-5 px-lg-8 px-md-7 ${cssClasses.CMS_MODULE}`}>
        <div className={mID}>
          <Row stretched>
            <Col xs={12} md={12} lg={10}>
              {!videoActive && previewImage && (
                <div className={`${mID}__preview`}>
                  <LazyImage
                    url={previewImage}
                  />
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href='#' onClick={this.onToggleVideo}>
                    <Icon name='play' color='var(--bs-mch-white)' />
                  </a>
                </div>
              )}
              {videoActive && (
                <>
                  {media(props.video_module_meida) === 'upload-video' && (
                    <VideoJSPlayer {...props} />
                  )}
                  {/* @ts-ignore */}
                  {media(props.video_module_meida) === 'youtube-video' && (
                    <YouTubeIFRAME
                      youtubeUrl={props.video_module_youtube_link}
                      // @ts-ignore
                      opts={{
                        playerVars: { autoplay: 0 },
                        host: 'https://www.youtube-nocookie.com'
                      }}
                    />
                  )}
                </>
              )}
            </Col>
          </Row>
        </div>
        {props.video_module_caption &&
          <div className={`${mID}__caption`}>
            <Text>{props.video_module_caption}</Text>
          </div>
        }
      </Container>
    )
  }
}

const RmVideoMStyled = styled(VideoM)`
  .${mID} {
    &__preview {
      position: relative;

      img {
        width: ${px2rem(640)};
        height: ${px2rem(360)};
      }

      svg {
        width: ${px2rem(50)};
        height: ${px2rem(50)};
        position: absolute;
        top: 40%;
        left: ${px2rem(310)};
      }
    }

    &__caption {
      > * {
        color: ${tokens.color.light.base.neutrals['500'].value};
        font-size: ${tokens.fontSize[1].value};
        line-height: ${tokensRenamed.lineHeights[6].value};
      }
    }
  }
`

export default RmVideoMStyled
